/* eslint-disable no-console */
import React, {useEffect, useState} from 'react'
import {useForm} from 'react-hook-form'
import {Button} from 'helpers/ui-components/Button'
import {useTranslation} from 'react-i18next'
import {Model} from 'helpers'
import {IFileObject, IFormField} from 'models/Common'
import {toast} from 'react-toastify'
import {IEditSkuProps} from 'models/ProductManagement'
import {productVariantUpdate} from 'utils/api/productManagementService'
import GenericFormBuilder from 'helpers/ui-components/GenericFormBuilder'
import {createPayload} from 'utils/helpers/genericForm'

type IProps = {
 loggedInUserId: number | undefined
 isDisabled?: Boolean
 canAdd?: Boolean
 selectedSku: IEditSkuProps | null
 productSkuList: IFormField[]
 setProductSkuList: (newState: IFormField[]) => void
 setLoader: (newState: boolean) => void
 handleAddUpdateSku: (newState: number) => void
 onSkuSaved?: (index: number, payload: IFormField) => void
}

const AddSku = (props: IProps) => {
 const {t} = useTranslation()
 const [showActionModel, setShowActionModel] =
  useState(true)
 const isEdit =
  props.selectedSku && props.selectedSku?.index >= 0
 const selectedIndex = props.selectedSku?.index
  ? props.selectedSku.index
  : 0
 const [uploadedFileData, setUploadedFileData] =
  useState<IFileObject>({
   ...props.productSkuList[selectedIndex]?.skuFileData,
  })
 const title = props.isDisabled
  ? t('productMgmt.addSKU.viewSku')
  : isEdit
  ? t('productMgmt.addSKU.editSku')
  : t('productMgmt.addSKU.title')

 const {
  register,
  control,
  watch,
  setValue,
  reset,
  setFocus,
  handleSubmit,
  getValues,
  unregister,
  formState: {errors, isValid},
 } = useForm({
  mode: 'all',
  reValidateMode: 'onChange',
  defaultValues: {
   ...(isEdit && {
    ...props.productSkuList[selectedIndex]?.skuFormData,
   }),
  },
 })

 const submitFormData = async (formData: IFormField) => {
  props.setLoader(true)
  const productSkuList = [...props.productSkuList]
  const payload = await createPayload(
   props.selectedSku?.skuConfig,
   formData,
   uploadedFileData
  )

  const skuTableData: IFormField = {
   variant_id: props.selectedSku?.skuId ?? '',
   variant_name: formData?.material_description,
   variant_sku: formData?.sku,
   uom: formData?.uom,
   price: formData?.variant_price,
   variant_images: payload?.images?.map(
    (_: string, i: number) =>
     uploadedFileData?.[`images.${i}`]?.signedUrl
   ),
  }
  console.log('skuTableData', skuTableData)
  const tableData = {
   skuFileData: {...uploadedFileData},
   skuFormData: {...payload},
   skuTableData,
  }
  if (isEdit) {
   if (props.selectedSku?.skuId) {
    const res = await productVariantUpdate({
     ...payload,
     id: props.selectedSku.skuId,
    })
    if (res) {
     toast.success(res)
    } else {
     return
    }
   }
   productSkuList[selectedIndex] = {...tableData}
   props.onSkuSaved?.(selectedIndex, payload)
  } else {
   productSkuList.push({...tableData})
  }
  setUploadedFileData({})
  props.setProductSkuList([...productSkuList])
  props.handleAddUpdateSku(-2)
  setShowActionModel(false)
  props.setLoader(false)
 }

 useEffect(() => {
  if (props.selectedSku) {
   setShowActionModel(true)
   if (isEdit) {
    reset(
     props.productSkuList[selectedIndex]?.skuFormData ?? {}
    )
    setUploadedFileData({
     ...props.productSkuList[selectedIndex]?.skuFileData,
    })
   }
  }
 }, [props.selectedSku])

 useEffect(() => {
  if (!showActionModel) {
   reset()
   props.handleAddUpdateSku(-2)
  }
 }, [showActionModel])

 return (
  <>
   <Model
    show={showActionModel}
    showHeader={false}
    closeBtnClass='absolute right-4 top-2 !bg-[#E6EBF0] !rounded-3xl w-7 h-7 !text-[#33393D]'
    header={''}
    close={() => {
     setShowActionModel(false)
    }}
    modelClass='md:w-[600px]'
    modelContainerClass='!rounded-2xl'
    modelBodyClass='p-10'
   >
    <div className='w-full'>
     <div className='w-full'>
      <p className='text-[#171B1F] text-left font-bold text-2xl'>
       {title}
      </p>
      <form
       method='POST'
       action=''
       onSubmit={handleSubmit(submitFormData)}
      >
       <div className='w-full mt-6 max-h-[400px] overflow-y-auto pr-0.5'>
        <div className='grid md:grid-cols-2 gap-3 w-full'>
         {props.selectedSku?.skuConfig &&
          props.selectedSku.skuConfig?.length > 0 && (
           <GenericFormBuilder
            isDisabled={props.isDisabled}
            itemConfigList={[
             {
              item_identifier: 'sku_details',
              fields: props.selectedSku.skuConfig,
             },
            ]}
            excludedFields={[]}
            uploadedFileData={uploadedFileData}
            setUploadedFileData={setUploadedFileData}
            itemIdentifier={'sku_details'}
            setLoader={props.setLoader}
            register={register}
            unregister={unregister}
            control={control}
            getValues={getValues}
            errors={errors}
            watch={watch}
            setValue={setValue}
            setFocus={setFocus}
            className=''
           />
          )}
        </div>
       </div>
       <div className='w-full mt-5 text-[#171B1F]'></div>
       {props.canAdd && (
        <div className='md:flex items-center justify-center mt-7'>
         <Button
          type={'submit'}
          disabled={!isValid}
          color='blue'
          className='disabled:text-white text-center w-full py-[9px] px-6 bg-[#4E83E4] 
                             !rounded-lg !text-base text-white font-semibold border-[#4E83E4]'
         >
          {t('productMgmt.addSKU.confirm')}
         </Button>
        </div>
       )}
      </form>
     </div>
    </div>
   </Model>
  </>
 )
}

export default AddSku
